import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import './warningShipmentModalComponent.css';
import shipmentWarningModalImage from '../../../src/assets/images/shipment_warning_modal_image.png';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';
import React, { useState } from 'react';
// import { fetchShipments, deleteShipmentById } from '../../redux/shipmentSlice';
import { useDispatch } from 'react-redux';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2), // To adjust the modal borderRadius
  },
}));

const WarningShipmentModalComponent = ({isOpen, onClose, handleDelete}) => {
  const dispatch = useDispatch();
  const handleClose = () => {
    // setOpen(false);
    onClose(false)
  };

  const handleDeleteBtnClick = () => {
    handleDelete();
    onClose(false);
  };

  return (
    <React.Fragment >
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Warning Shipment Modal
      </Button> */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        PaperProps={{
            style: {
                maxWidth: '370px', // Adjust the maxWidth as needed
                width: '100%',
                maxHeight:'360px'
            },
        }}
        maxHeight="300" // Adjust the maxHeight as needed
        
      >
        <DialogTitle sx={{ m: 0, p: "0px 0px" }} id="customized-dialog-title">
          {/* Modal title */}
              <div className='warningShipmentModalImagediv'>  
                <img 
                  className='warningShipmentModalImage'
                  src={shipmentWarningModalImage}
                />
                <h4 
                  className='headingForWarningShipmentModal'
                > Warning </h4>
                <h4 className='subHeadingForWwarningShipmentModal'>
                    Do you really want to delete
                </h4>
              </div>
              <div>
                <hr style={{width:"100%"}}>
                </hr>
              </div>
              <div >
                <Button className='noButton' onClick={handleClose}>No keep it</Button>
                <Button className='deleteButton' onClick={handleDeleteBtnClick}>Yes Delete it</Button>
              </div>
        </DialogTitle>
        
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            backgroundColor:"white",
            height: "7%",
            width: "6%",
          }}
        >
          <CloseIcon />
        </IconButton>
      </BootstrapDialog>
    </React.Fragment>
  );
}

export default WarningShipmentModalComponent;